module.exports = __webpack_public_path__ + "img/blue_043.5310fd49.png";